<template>
  <div class="out-container footer-section">
    <div class="full-width q-pa-sm" :style="footerStyle">
      <div :class="['container', ...(hasFooterColor && ['q-pt-lg'])].join(' ')">
        <QSeparator v-if="!hasFooterColor" class="q-my-lg full-width" />
        <p
          v-html="calculator.disclaimerText"
          :class="isDarkColour ? 'disclaimerText footer-white' : 'disclaimerText'"
          ref="disclaimerText"
        ></p>
        <p v-html="calculator.footerText" :class="isDarkColour ? 'footer-white' : 'footer-grey'"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { QSeparator } from 'quasar';
import { mapGetters } from 'vuex';
import { disclaimerDialogMixin } from '@/mixins/calculator';

export default {
  name: 'CalculatorFooter',
  components: { QSeparator },
  mixins: [disclaimerDialogMixin],
  computed: {
    ...mapGetters({
      calculator: 'theme/getCalculator',
      whiteLabel: 'theme/getWhitelabel'
    }),
    isWhiteColor() {
      return !!this.calculator?.footerColour?.match(/^(?:white|#fff(?:fff)?)$/i);
    },
    isDarkColour() {
      const luminanceThreshold = 0.5;
      let color = this.calculator?.footerColour;

      // Regex to match 3-digit or 6-digit hex color codes
      const hexColorRegex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;

      if (!hexColorRegex.test(color)) {
        return;
      }

      color = color.replace('#', '');

      // Convert 3-digit hex color to 6-digit hex color
      if (color.length === 3) {
        color = color
          .split('')
          .map((c) => c + c)
          .join('');
      }

      // Split into RGB components
      const r = parseInt(color.substr(0, 2), 16);
      const g = parseInt(color.substr(2, 2), 16);
      const b = parseInt(color.substr(4, 2), 16);

      // Calculate the brightness level using luminance formula
      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

      // Determine if the color is "dark" or "light" based on the luminance threshold
      return luminance < luminanceThreshold;
    },
    footerStyle() {
      return {
        background: this.calculator?.footerColour ? this.calculator.footerColour : 'inherit'
      };
    },
    hasFooterColor() {
      return !!this.calculator?.footerColour && !this.isWhiteColor;
    }
  },
  mounted() {
    const popupSpans = document.querySelectorAll('.calculatorPopup');

    const state = this;

    if (popupSpans?.length) {
      popupSpans.forEach((span) => {
        span.textContent = span.textContent.trim().replace(/\s+/g, ' ');

        span.addEventListener('click', function (event) {
          state.showDisclaimerDialog();
        });
      });
    }
  }
};
</script>
<style lang="sass">
.footer-white
  span, a
    color: #fff!important
    font-weight: 800

.footer-grey
  span, a
    color: $grey-8!important
    font-weight: 800

.calculatorPopup
  font-weight: 800
  .q-icon
    display: none!important
</style>
<style lang="sass" scoped>
.footer-section
  margin-top: 25px
.content
  max-width: 1620px
.out-container
  left: 50%
  margin-left: -50vw
  margin-right: -50vw
  max-width: 100vw
  position: relative;
  right: 50%
  width: 100vw
@media (max-width:735px)
  .sticky-footer .footer-section > div
    padding-bottom: 70px
</style>
